import moment from 'moment';

const unapproved_pos_fields = {
  'Linea naviera': {
    field: 'shipping_line',
    callback: shipping_line => {
      return shipping_line ? shipping_line.name : ''
    }
  },
  'Cliente': {
    field: 'company',
    callback: company => {
      return company ? company.name : ''
    }
  },
  'Facturar a': {
    field: 'company',
    callback: company => {
      return company ? company.company_bill.name : ''
    }
  },
  'BL/BK': 'doc_number',
  'Solicitante': {
    field: 'applicant',
    callback: user => {
      return user ? `${user.name} ${user.last_name}` : ''
    }
  },
  'Cantidad de contenedores': {
    field: 'requeriments',
    callback: rqs => {
      return rqs.length
    }
  },
  'Fecha operación': {
    field: 'requeriments',
    callback: rqs => {
      return moment(rqs[0].date).isValid() ? moment(rqs[0].date).format('DD/MM/YYYY HH:mm') : ''
    }
  },
  'Estado': 'status.name'
}

export default unapproved_pos_fields;